export const Prices = [
    {
        _id: 0,
        name: "$0 to $19",
        array: [0, 19]
    },
    {
        _id: 1,
        name: "$20 to $59",
        array: [20, 59]
    }, {
        _id: 2,
        name: "$60 to $119",
        array: [60, 119]
    },
    {
        _id: 3,
        name: "$120 to $299",
        array: [120, 299]
    },
    {
        _id: 4,
        name: "$300 to more",
        array: [300, 999]
    },

]